import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from 'src/environments/environment';



interface ErroeObject {
  caller?: string;
  errorTitle?: string;
  errorMessage?: string;
}

interface Extras {
  contentType?: {
    isFormDataContent?: boolean;
    isJsonContent?: boolean;
  };
  customHeaders?: object;
}

interface HttpResponseData {
  data?: any;
  message?: any;
  error?: any;
  success?: any;
}

@Injectable()
export class ApiHandlerService {

  public stripeKey = environment.stripeKey
  public BASE_URL = environment.baseUrl + '/api/';

  public baseApiUrl = this.BASE_URL;
  public baseUrl = this.BASE_URL + 'users/';
  public driverbaseUrl = this.BASE_URL + 'site/driver/';
  public adminBaseUrl = this.BASE_URL + 'site/';
  public marketingBaseUrl = this.BASE_URL + 'marketing/';
  public petsBaseUrl = this.BASE_URL + 'pets';

  constructor(private http: HttpClient) { }

  apiGet(url, params?, extras?: Extras) {
    let options = this.renderHeaders(extras);
    options = this.appendParams(options, params);
    return this.http.get<any>(url, options);
  }

  apiPost(url, reqBody, params?, extras?: Extras) {
    let options = this.renderHeaders(extras);
    options = this.appendParams(options, params);
    reqBody = reqBody ? reqBody : {};
    return this.http.post<HttpResponseData>(url, reqBody, options)
  }


  apiUpdate(url, reqBody, params?, extras?: Extras) {
    let options = this.renderHeaders(extras);
    options = this.appendParams(options, params);
    return this.http.put(url, reqBody, options);
  }

  apiDelete(url, params?, extras?) {
    let options = this.renderHeaders(extras);
    options = this.appendParams(options, params);
    return this.http.delete(url);
  }

  private renderHeaders(extras: Extras) {
    // if extras is present then apply check
    if (extras) {
      if (extras.contentType && extras.contentType.isFormDataContent) {
        return {};
      } else if (extras.customHeaders) {
        let headers = new HttpHeaders();
        let customHeaders = Object.assign({}, extras.customHeaders);
        for (const key in customHeaders) {
          if (customHeaders.hasOwnProperty(key)) {
            headers = headers.append(key, customHeaders[key]);
          }
        }
        return Object.assign({}, {
          'Content-Type': 'application/json',
          'Cache-Control': 'private, no-cache, no-store, must-revalidate',
          'Expires': '-1',
          'Pragma': 'no-cache'
        }, { headers: headers });
      }
    } else {
      // else assume it to be json data
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'private, no-cache, no-store, must-revalidate',
          'Expires': '-1',
          'Pragma': 'no-cache'
        })
      };
    }
  }

  private appendParams(originalOptions, paramsObj) {
    let params = new HttpParams();
    for (const key in paramsObj) {
      if (paramsObj.hasOwnProperty(key)) {
        params = params.append(key, paramsObj[key]);
      }
    }
    return Object.assign({}, originalOptions, { params: params });
  }
}
